import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from "src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component";
import { LocalStorageService } from "src/app/_services/localStorage/local-storage.service";
import { AllocationService } from "src/app/_services/resource-allocation/allocation.service";
import { AttendanceService } from "src/app/_services/attendance/attendance.service";
import 'rxjs/add/operator/filter';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-short-leave',
    templateUrl: './short-leave.component.html',
    styleUrls: ['./short-leave.component.scss']
})
export class ShortLeaveComponent implements OnInit {

    shortLeaveForm;
    employeeForm;
    form: FormGroup;
    rowData: any;
    public columnDefs: ColDef[];
    modeAction: number = 1 //1 - create // 2 - update
    // gridApi and columnApi
    private api: GridApi;
    private columnApi: ColumnApi;
    defaultColDef: any;
    rowSelection: any;
    tenantId: string;
    currentUser: any;
    selectedFile: File;
    sampleGridFrameworkComponents: any;
    gridLength = 0;
    selectedCheckboxData = [];
    userDropdownList = [];
    selectedRow: any;
    deleteConfirmationMsg = 'Are you sure you want to delete shift for';
    isAdmin: boolean;
    isSupervisor: any = false;
    minDate: any;
    date: Date;
    TodayDate: string;

    constructor(
        private storageService: LocalStorageService,
        private formBuilder: FormBuilder,
        private allocationService: AllocationService,
        private router: Router,
        private attendanceService: AttendanceService,
        private snackBar: MatSnackBar,
        private datePipe: DatePipe,
    ) {
        this.defaultColDef = {
            flex: 1,
            minWidth: 100,
            resizable: true,
        };
        this.rowSelection = 'multiple';
        this.columnDefs = this.createColumnDefs();

        this.sampleGridFrameworkComponents = {
            actionRowRendererComponent: ActionItemsGridRowRendererComponent,
        };

        this.form = this.formBuilder.group({
            file: ['', Validators.required]
        });

        this.shortLeaveForm = this.formBuilder.group({
            id: new FormControl(''),
            userId: new FormControl(''),
            userName: new FormControl(''),
            firstHalf: new FormControl(''),
            leaveDate: new FormControl('')
        });

        this.employeeForm = this.formBuilder.group({
            id: new FormControl(''),
            userId: new FormControl(''),
            userName: new FormControl(''),
        });

    }

    ngOnInit(): void {
        this.tenantId = this.storageService.get('tenantId');
        this.currentUser = JSON.parse(this.storageService.get('currentUser'));
        this.isAdmin = this.currentUser.roles.includes('RoleHrmAdministrator');
        this.date = new Date();
        this.TodayDate = this.datePipe.transform(this.date, 'yyyy-MM-dd');
        const twoMonthsAgo = new Date();
        twoMonthsAgo.setMonth(this.date.getMonth() - 4);
        this.minDate = this.datePipe.transform(twoMonthsAgo, 'yyyy-MM-dd');
        this.getUserList();
        this.getShortLeave();
    }

    createShortLeave() {
        let shortLeaveDatails = {
            userId: this.shortLeaveForm.get('userId').value.split(' . ')[0],
            firstHalf: this.shortLeaveForm.get('firstHalf').value,
            leaveDate: this.shortLeaveForm.get('leaveDate').value,
            status: 'Submitted',
            approvedByUser: null
        }
        this.attendanceService.createShortLeave(shortLeaveDatails).subscribe(response => {
            this.snackBar.open('Short leave applied', 'Close', { duration: 3000 });
            this.getShortLeave();
            $('#closeCreateModal').trigger("click");
        })
    }

    getUserList() {
        this.userDropdownList = [];
        if (this.isAdmin) {
            this.allocationService.getUserDetails().subscribe((response) => {
                for (let item of response) {
                    this.userDropdownList.push(
                        `${item.id} . ${item.firstName} ${item.lastName}`
                    );
                }
                this.userDropdownList.push(
                    `0 . All Users`
                );
            });
        }
        else {
            this.allocationService.getReportees().subscribe((response) => {
                if (response.length > 0) {
                    this.isSupervisor = true;
                    for (let item of response) {
                        this.userDropdownList.push(
                            `${item.id} . ${item.firstName} ${item.lastName}`
                        );
                    }
                }
            });
        }
    }

    getShortLeave() {
        let userId = this.employeeForm.get('userId').value.split(' . ')[0];
        if (userId) {
            this.attendanceService.getShortLeaveByUserId(userId).subscribe((response: any) => {
                this.rowData = response;
            });
        }
        else {
            if (this.isAdmin) {
                this.attendanceService.getShortLeave().subscribe((response: any) => {
                    this.rowData = response;
                });
            }
            else {
                this.attendanceService.getShortLeaveByUserId(this.currentUser.id).subscribe((response: any) => {
                    this.rowData = response;
                });
            }
        }
    }

    onGridReady(params): void {
        this.api = params.api;
        console.log('qqqq', this.api);
        this.columnApi = params.columnApi;
        this.api.sizeColumnsToFit();
    }

    private createColumnDefs() {
        return [
            {
                headerName: "Date",
                field: "leaveDate", 'width': 200,
                filter: true,
                editable: false,
                sortable: true,
                // headerCheckboxSelection: this.isFirstColumn,
                // checkboxSelection: this.isFirstColumn,
            },
            {
                headerName: 'Employee',
                field: 'userId',
                valueGetter: function (params) {
                    return params.data.userId + " . " + params.data.userName;
                },
                filter: true,
                editable: false,
                sortable: true,
            },
            {
                headerName: 'Short Leave Time',
                cellRenderer: (params) => {
                    if (params.data.firstHalf === true) {
                        return 'First Half'
                    }
                    else {
                        return 'Second Half'
                    }
                },
                filter: true,
                editable: false,
                sortable: true
            },
            {
                headerName: 'Created Date',
                field: 'createdDate',
                filter: true,
                editable: false,
                sortable: true
            },
            {
                headerName: 'Status',
                field: 'status',
                cellStyle: (params) => {
                    if (params.value === 'Save' || params.value === 'save') {
                        return { color: 'blue', 'font-weight': 'bold' };
                    } else if (params.value === 'Submitted' || params.value === 'submitted') {
                        return { color: 'orange', 'font-weight': 'bold' };
                    } else if (params.value === 'Approved' || params.value === 'approved') {
                        return { color: 'green', 'font-weight': 'bold' };
                    } else if (params.value === 'Reject' || params.value === 'reject') {
                        return { color: 'red', 'font-weight': 'bold' };
                    } else if (
                        params.value === 'Withdraw' ||
                        params.value === 'withdraw'
                    ) {
                        return { color: 'grey', 'font-weight': 'bold' };
                    }
                    return null;
                },
                filter: true,
                editable: false,
                sortable: true
            },
            {
                headerName: 'Approved By User',
                field: 'approvedByUser',
                filter: true,
                editable: false,
                sortable: true
            },
        ]
    }

    createOpenModal() {
        this.modeAction = 1;
        this.shortLeaveForm.reset();
        this.shortLeaveForm.patchValue({
            userId: '',
            userName: '',
            firstHalf: '',
            leaveDate: ''
        });
        this.shortLeaveForm.value.userId = this.currentUser.id + ' . ' + this.currentUser.firstName + ' ' + this.currentUser.lastName;
        this.shortLeaveForm.patchValue(this.shortLeaveForm.value);
    }

    onSelectionChanged(event) {
        this.selectedCheckboxData = []
        let select = event.api.getSelectedNodes();
        for (let item of select) {
            this.selectedCheckboxData.push(item.data)
        }
    }

    isFirstColumn(params) {
        const displayedColumns = params.columnApi.getAllDisplayedColumns();
        const thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    }

    backToAttendancePage() {
        this.router.navigate([this.tenantId + '/dashboard/hr/attendance']);
    }

    shifts() {
        this.router.navigate([this.tenantId + '/dashboard/hr/shift-details']);
    }

}